<div fxLayout="row wrap">
    <div fxFlex="50" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2" *ngIf="nbLocation">        
        <mat-card class="gradient-green tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h2>{{nbLocation}}</h2>         
            <p>Locations</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2" *ngIf="nbPaiement">        
        <mat-card class="gradient-red tile p-2"> 
            <mat-icon>thumb_up_alt</mat-icon> 
            <h2>{{nbPaiement}}</h2>         
            <p>Paiements</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2" *ngIf="nbUser">
        <mat-card class="gradient-orange tile p-2">
            <mat-icon>group</mat-icon> 
            <h2>{{nbUser}}</h2>         
            <p>Utilisateurs</p> 
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-2" *ngIf="nbCar">
        <mat-card class="gradient-pink tile p-2">
            <mat-icon>shopping_cart</mat-icon> 
            <h2>{{nbCar}}</h2>         
            <p>Vehicules</p> 
        </mat-card>
    </div>
</div>